import axios from "../axiosInstance";
import { FetchUserEnrollmentsParams, FetchEnrollmentsResponse } from "./types";

export const fetchUserEnrollments = async (
  params: FetchUserEnrollmentsParams,
): Promise<FetchEnrollmentsResponse> => {
  const queryParams = new URLSearchParams();

  if (params.status) {
    queryParams.append('status', params.status);
  }
  if (params.page) {
    queryParams.append('page', params.page.toString());
  }
  if (params.limit) {
    queryParams.append('limit', params.limit.toString());
  }

  const queryString = queryParams.toString();
  const url = `/api/learning-center/users/${params.userId}/enrollments${queryString ? `?${queryString}` : ''}`;

  const response = await axios.get<FetchEnrollmentsResponse>(url);
  return response.data;
};
